// ================================================================
//  BmelEditorDialogController
// ================================================================

angular.module('bizmetryApp')

    .controller('BmelEditorDialogController', [
        '$scope', '$mdDialog', '$timeout',
        'BmelEditorService',
        'targetComponentId', 'targetComponentName', 'currentExpression', 'availableSources',
        'expectedBmelType', 'expectedTypeLabel', 'enumValues', 'resourceTypes',

        function ($scope, $mdDialog, $timeout,
            BmelEditorService,
            targetComponentId, targetComponentName, currentExpression, availableSources,
            expectedBmelType, expectedTypeLabel, enumValues, resourceTypes) {

            var ctrl = this;
            var _editor = null;

            // ── State ────────────────────────────────────────────────────

            ctrl.targetComponentId   = targetComponentId;
            ctrl.targetComponentName = targetComponentName;
            ctrl.expression          = currentExpression || '';
            ctrl.availableSources    = availableSources || [];
            ctrl.validationErrors    = [];
            ctrl.isLoading           = true;
            ctrl.expectedBmelType    = expectedBmelType || null;

            ctrl.sourceGroups  = _buildSourceGroups(availableSources);

            ctrl.functionsList  = [];
            ctrl.functionsError = false;

            // ── Function search ──────────────────────────────────────────

            ctrl.fnSearch = '';

            ctrl.filteredFunctions = function () {
                var q = (ctrl.fnSearch || '').trim().toLowerCase();
                if (!q) return ctrl.functionsList;
                return ctrl.functionsList.filter(function (fn) {
                    return (fn.name          && fn.name.toLowerCase().indexOf(q)          !== -1)
                        || (fn.desc          && fn.desc.toLowerCase().indexOf(q)          !== -1)
                        || (fn.categoryLabel && fn.categoryLabel.toLowerCase().indexOf(q) !== -1);
                });
            };

            // ── Source search ────────────────────────────────────────────

            ctrl.srcSearch          = '';
            ctrl.srcMatchCount      = 0;
            ctrl.cachedSourceGroups = ctrl.sourceGroups;   // starts unfiltered

            function _applySourceFilter(q) {
                q = (q || '').trim().toLowerCase();

                if (!q) {
                    ctrl.cachedSourceGroups = ctrl.sourceGroups;
                    ctrl.srcMatchCount      = ctrl.availableSources.length;
                    return;
                }

                var count  = 0;
                var result = [];

                ctrl.sourceGroups.forEach(function (opGroup) {
                    var filteredTypeGroups = [];
                    opGroup.typeGroups.forEach(function (tg) {
                        var matchedFields = tg.fields.filter(function (src) {
                            return (src.label && src.label.toLowerCase().indexOf(q) !== -1)
                                || (src.ref   && src.ref.toLowerCase().indexOf(q)   !== -1);
                        });
                        if (matchedFields.length > 0) {
                            count += matchedFields.length;
                            filteredTypeGroups.push({ sourceType: tg.sourceType, fields: matchedFields });
                        }
                    });
                    if (filteredTypeGroups.length > 0) {
                        result.push({ opIdx: opGroup.opIdx, opName: opGroup.opName, typeGroups: filteredTypeGroups });
                    }
                });

                ctrl.cachedSourceGroups = result;
                ctrl.srcMatchCount      = count;
            }

            $scope.$watch(function () { return ctrl.srcSearch; }, _applySourceFilter);

            // Tooltip state
            ctrl.hoveredFn    = null;
            ctrl.tooltipStyle = { left: '-9999px', top: '-9999px' };

            // ── Load functions ───────────────────────────────────────────

            // ── Monaco init ──────────────────────────────────────────────

            // _safeApply — runs fn inside $apply only when no digest is active,
            // preventing [$rootScope:inprog] when Monaco fires synchronous events
            // (e.g. onDidChangeModelContent) during an ng-click $apply cycle.
            function _safeApply(fn) {
                if ($scope.$$phase || $scope.$root.$$phase) {
                    fn();
                } else {
                    $scope.$apply(fn);
                }
            }

            // Load functions FIRST, then init Monaco — guarantees KNOWN_FN_NAMES
            // is populated before the tokenizer and validator run for the first time.
            // Without this ordering, the first editor open sees an empty function list
            // and reports "bmel:self is not a valid function", etc.
            BmelEditorService.loadFunctions()
                .then(function (functions) {
                    ctrl.functionsList = functions;
                    // Re-register the Monaco language tokenizer now that KNOWN_FN_NAMES
                    // is populated — the initial registration at Monaco load time used [].
                    BmelEditorService.refreshLanguageTokenizer();
                })
                .catch(function (err) {
                    console.error('[BmelEditorDialogController] Failed to load BMEL functions:', err && err.status);
                    ctrl.functionsError = true;
                });

            $timeout(function () {
                var container = document.getElementById('bmel-monaco-container');
                if (!container) { ctrl.isLoading = false; return; }

                BmelEditorService.registerCompletions(availableSources, enumValues || [], resourceTypes || []);

                _editor = window.monaco.editor.create(container, {
                    value: ctrl.expression,
                    language: 'bmel',
                    theme: 'bmel-dark',
                    automaticLayout: true,
                    minimap: { enabled: false },
                    lineNumbers: 'off',
                    scrollBeyondLastLine: false,
                    wordWrap: 'on',
                    fontSize: 14,
                    fontFamily: 'Consolas, "Courier New", monospace',
                    suggestOnTriggerCharacters: true,
                    quickSuggestions: { other: true, comments: false, strings: false },
                    folding: false,
                    lineDecorationsWidth: 10,
                    overviewRulerLanes: 0,
                    hideCursorInOverviewRuler: true,
                    scrollbar: { vertical: 'auto', horizontal: 'hidden' },
                    padding: { top: 16, bottom: 16 },
                    renderLineHighlight: 'all',
                    contextmenu: false
                });

                _editor.onDidChangeModelContent(function () {
                    var val = _editor.getValue();
                    // Monaco events can fire during an existing $apply (e.g. when
                    // insertSourceRef triggers a content change via ng-click).
                    // _safeApply prevents the [$rootScope:inprog] error.
                    _safeApply(function () {
                        ctrl.validationErrors = BmelEditorService.validateExpression(val, availableSources, expectedBmelType, expectedTypeLabel, resourceTypes);
                        _pushMarkers(ctrl.validationErrors);
                    });
                });

                ctrl.validationErrors = BmelEditorService.validateExpression(ctrl.expression, availableSources, expectedBmelType, expectedTypeLabel, resourceTypes);
                _pushMarkers(ctrl.validationErrors);
                ctrl.isLoading = false;
                $scope.$apply();

                $timeout(function () {
                    if (!_editor) return;
                    _editor.focus();
                    var end = _editor.getModel().getFullModelRange().getEndPosition();
                    _editor.setPosition(end);
                }, 60);

            }, 150);

            // ── Tooltip — appended to document.body ─────────────────────

            var _tooltipEl    = null;
            var _tooltipTimer = null;

            function _createTooltipEl() {
                _tooltipEl = document.createElement('div');
                _tooltipEl.style.cssText = [
                    'position:fixed',
                    'z-index:99999',
                    'width:520px',
                    'max-height:480px',
                    'overflow-y:auto',
                    'background:#1e1b3a',
                    'border:1px solid #6366f1',
                    'border-radius:8px',
                    'box-shadow:0 12px 40px rgba(0,0,0,.75),0 0 0 1px rgba(99,102,241,.2)',
                    'pointer-events:none',
                    'display:none',
                    'font-family:inherit',
                    'font-size:13px',
                    'left:-9999px',
                    'top:-9999px'
                ].join(';');
                document.body.appendChild(_tooltipEl);
            }

            function _esc(str) {
                return String(str || '')
                    .replace(/&/g, '&amp;')
                    .replace(/</g, '&lt;')
                    .replace(/>/g, '&gt;');
            }

            function _renderTooltip(fn) {
                var S = {
                    sig:       'padding:12px 14px 10px;font-family:Consolas,monospace;font-size:11.5px;color:#5eead4;border-bottom:1px solid rgba(99,102,241,.3);line-height:1.55;word-break:break-word;background:rgba(99,102,241,.08)',
                    argsWrap:  'padding:10px 14px;border-bottom:1px solid rgba(99,102,241,.15)',
                    argsTitle: 'font-size:9px;font-weight:700;text-transform:uppercase;letter-spacing:.9px;color:rgba(255,255,255,.35);margin-bottom:8px',
                    argName:   'font-family:Consolas,monospace;font-size:11.5px;font-weight:700;color:#a5b4fc',
                    argType:   'font-family:Consolas,monospace;font-size:10.5px;color:#67e8f9',
                    argVar:    'font-size:9px;color:#fbbf24;font-weight:700;text-transform:uppercase;padding:1px 4px;background:rgba(251,191,36,.12);border-radius:3px',
                    argDesc:   'font-size:10.5px;color:#94a3b8;line-height:1.45;padding-left:2px',
                    noargs:    'padding:8px 14px;font-size:11px;color:rgba(255,255,255,.3);font-style:italic;border-bottom:1px solid rgba(99,102,241,.12)',
                    desc:      'padding:10px 14px;font-size:11px;color:#cbd5e1;line-height:1.55'
                };

                var h = '<div style="' + S.sig + '">' + _esc(fn.sig || fn.name) + '</div>';

                if (fn.arguments && fn.arguments.length > 0) {
                    h += '<div style="' + S.argsWrap + '">';
                    h += '<div style="' + S.argsTitle + '">Arguments</div>';
                    fn.arguments.forEach(function (arg, i) {
                        var border = i > 0 ? 'border-top:1px solid rgba(255,255,255,.05);' : '';
                        h += '<div style="padding:5px 0;' + border + '">';
                        h += '<div style="display:flex;align-items:baseline;gap:7px;flex-wrap:wrap;margin-bottom:2px">';
                        h += '<span style="' + S.argName + '">' + _esc(arg.name) + '</span>';
                        h += '<span style="' + S.argType + '">' + _esc(arg.type) + '</span>';
                        if (arg.variadic) h += '<span style="' + S.argVar + '">variadic</span>';
                        h += '</div>';
                        if (arg.description) h += '<div style="' + S.argDesc + '">' + _esc(arg.description) + '</div>';
                        h += '</div>';
                    });
                    h += '</div>';
                } else {
                    h += '<div style="' + S.noargs + '">No arguments</div>';
                }

                if (fn.desc) h += '<div style="' + S.desc + '">' + _esc(fn.desc) + '</div>';

                _tooltipEl.innerHTML = h;
            }

            ctrl.showTooltip = function (fn, $event) {
                if (_tooltipTimer) { $timeout.cancel(_tooltipTimer); _tooltipTimer = null; }

                var mouseX = $event.clientX;
                var mouseY = $event.clientY;

                _tooltipTimer = $timeout(function () {
                    _tooltipTimer = null;
                    if (!_tooltipEl) _createTooltipEl();

                    _renderTooltip(fn);

                    var TOOLTIP_W = 520;
                    var MARGIN    = 12;
                    var PADDING   = 8;   // min gap from viewport edges

                    // Horizontal: prefer right of cursor, flip left if it clips.
                    var left = mouseX + MARGIN;
                    if (left + TOOLTIP_W > window.innerWidth - PADDING) left = mouseX - TOOLTIP_W - MARGIN;
                    left = Math.max(PADDING, left);

                    // Measure real rendered height before deciding direction.
                    // Show off-screen first so the browser lays it out, then measure.
                    _tooltipEl.style.width     = TOOLTIP_W + 'px';
                    _tooltipEl.style.maxHeight = '480px';
                    _tooltipEl.style.left      = '-9999px';
                    _tooltipEl.style.top       = '-9999px';
                    _tooltipEl.style.display   = 'block';
                    var realH = Math.min(_tooltipEl.scrollHeight, 480);

                    var spaceBelow = window.innerHeight - mouseY - MARGIN - PADDING;
                    var spaceAbove = mouseY - MARGIN - PADDING;
                    var maxH, top;

                    // Flip upward when content doesn't fit below but fits above,
                    // or when there's substantially more room above.
                    if (realH <= spaceBelow || spaceBelow >= spaceAbove) {
                        // Open downward
                        top  = mouseY + MARGIN;
                        maxH = Math.min(480, spaceBelow);
                    } else {
                        // Not enough room below — open upward
                        maxH = Math.min(480, spaceAbove);
                        top  = mouseY - MARGIN - Math.min(realH, maxH);
                    }
                    top = Math.max(PADDING, top);

                    _tooltipEl.style.left      = left + 'px';
                    _tooltipEl.style.top       = top  + 'px';
                    _tooltipEl.style.maxHeight = maxH + 'px';
                }, 1000);
            };

            ctrl.hideTooltip = function () {
                if (_tooltipTimer) { $timeout.cancel(_tooltipTimer); _tooltipTimer = null; }
                if (_tooltipEl) _tooltipEl.style.display = 'none';
            };

            // ── Source actions ───────────────────────────────────────────

            ctrl.insertSourceRef = function (src) {
                if (!_editor) return;
                _insertAt(src.ref);
            };

            ctrl.insertFunction = function (fn) {
                if (!_editor) return;
                _insertAt(fn.name + '(');
            };

            // ── Validation ───────────────────────────────────────────────

            ctrl.hasErrors = function () {
                return ctrl.validationErrors.some(function (e) { return e.severity === 'error'; });
            };

            ctrl.hasWarnings = function () {
                return !ctrl.hasErrors()
                    && ctrl.validationErrors.some(function (e) { return e.severity === 'warning'; });
            };

            ctrl.editorBorderClass = function () {
                if (ctrl.isLoading) return '';
                if (ctrl.hasErrors()) return 'bmel-border--error';
                if (ctrl.hasWarnings()) return 'bmel-border--warning';
                return 'bmel-border--ok';
            };

            // ── Source helpers ───────────────────────────────────────────

            ctrl.sourceTypeIcon = function (sourceType) {
                return ({
                    REQUEST_FIELD: 'upload',
                    RESPONSE_FIELD: 'download',
                    HEADER: 'http',
                    CUSTOM_HEADER: 'http',
                    URI_PARAM: 'link',
                    QUERY_PARAM: 'search',
                    CONTEXT: 'code'
                })[sourceType] || 'data_object';
            };

            ctrl.sourceTypeLabel = function (sourceType) {
                return ({
                    REQUEST_FIELD: 'Request Body',
                    RESPONSE_FIELD: 'Response Body',
                    HEADER: 'Headers',
                    CUSTOM_HEADER: 'Custom Headers',
                    URI_PARAM: 'URI Params',
                    QUERY_PARAM: 'Query Params',
                    CONTEXT: 'Context'
                })[sourceType] || sourceType;
            };

            // ── Save / cancel ────────────────────────────────────────────

            ctrl.save = function () {
                if (ctrl.isLoading || ctrl.hasErrors()) return;
                var expr = _editor ? _editor.getValue().trim() : ctrl.expression.trim();
                $mdDialog.hide(expr);
            };

            ctrl.cancel = function () {
                $mdDialog.cancel();
            };

            // ── Private ──────────────────────────────────────────────────

            function _insertAt(text) {
                var sel = _editor.getSelection();
                _editor.executeEdits('bmel-insert', [{
                    range: new window.monaco.Range(
                        sel.startLineNumber, sel.startColumn,
                        sel.endLineNumber, sel.endColumn
                    ),
                    text: text
                }]);
                _editor.focus();
            }

            function _pushMarkers(errors) {
                if (!_editor || !window.monaco) return;
                window.monaco.editor.setModelMarkers(
                    _editor.getModel(), 'bmel',
                    errors.map(function (e) {
                        return {
                            startLineNumber: e.line || 1,
                            startColumn: e.col || 1,
                            endLineNumber: e.line || 1,
                            endColumn: (e.col || 1) + (e.length || 8),
                            message: e.message,
                            severity: e.severity === 'error'
                                ? window.monaco.MarkerSeverity.Error
                                : window.monaco.MarkerSeverity.Warning
                        };
                    })
                );
            }

            function _buildSourceGroups(sources) {
                var byOp = {};
                sources.forEach(function (src) {
                    var key = src.opIdx !== undefined ? src.opIdx : 'shared';
                    if (!byOp[key]) byOp[key] = { opIdx: src.opIdx, opName: src.opName || ('Op ' + src.opIdx), byType: {} };
                    var t = src.sourceType || 'OTHER';
                    if (!byOp[key].byType[t]) byOp[key].byType[t] = [];
                    byOp[key].byType[t].push(src);
                });
                var ORDER = ['REQUEST_FIELD', 'RESPONSE_FIELD', 'URI_PARAM', 'QUERY_PARAM', 'HEADER', 'CUSTOM_HEADER', 'CONTEXT', 'OTHER'];
                var groups = [];
                Object.keys(byOp).sort().forEach(function (opKey) {
                    var op = byOp[opKey];
                    var typeGroups = [];
                    ORDER.forEach(function (t) {
                        if (op.byType[t] && op.byType[t].length) {
                            typeGroups.push({ sourceType: t, fields: _sortWithArrayColumns(op.byType[t]) });
                        }
                    });
                    if (typeGroups.length) groups.push({ opIdx: op.opIdx, opName: op.opName, typeGroups: typeGroups });
                });
                return groups;
            }

            function _sortWithArrayColumns(fields) {
                var parents  = fields.filter(function (f) { return !f.isArrayColumn; });
                var columns  = fields.filter(function (f) { return  f.isArrayColumn; });
                if (!columns.length) { return fields; }

                var result = [];
                parents.forEach(function (parent) {
                    result.push(parent);
                    var normParent = (parent.path || '').replace(/\[\d+\]/g, '');
                    columns.forEach(function (col) {
                        var normCol = (col.path || '').replace(/\[\d+\]/g, '');
                        if (normCol.indexOf(normParent + '.') === 0) result.push(col);
                    });
                });
                columns.forEach(function (col) {
                    if (!result.some(function (r) { return r.id === col.id; })) result.push(col);
                });
                return result;
            }

            $scope.$on('$destroy', function () {
                if (_editor)    { _editor.dispose(); _editor = null; }
                if (_tooltipTimer) { $timeout.cancel(_tooltipTimer); _tooltipTimer = null; }
                if (_tooltipEl && _tooltipEl.parentNode) {
                    _tooltipEl.parentNode.removeChild(_tooltipEl);
                    _tooltipEl = null;
                }
            });
        }
    ]);